import { render, staticRenderFns } from "./IconCodeSnippetReact.vue?vue&type=template&id=4b885e3d"
import script from "./IconCodeSnippetReact.vue?vue&type=script&lang=js"
export * from "./IconCodeSnippetReact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports